// Handles both "?=<id>" and "?id=<id>"
export function parseActivityId(search) {
  if (!search) return null;
  const params = new URLSearchParams(search);
  // Standard "?id=<...>"
  const byKey = params.get("id");
  if (byKey) return byKey;

  // Non-standard lone value: "?=<...>" → key is empty string
  const lone = params.get("");
  return lone || null;
}
